import React from 'react';
import useSafeState from "../../../../../../../useSafeState"
import * as api from '../../../../../../../Auth/auth'
import TableComp from '../../../../../../../components/Table/TableComp'


export default function GetGuideAripiprazole() {

  const [value, setValue] = useSafeState({});
  const [data, setData] = React.useState(React.useMemo(() => []));
  const [loading, setLoading] = React.useState(false);
    
    React.useEffect( () => {
      getData()
  }, [])

  async function getData() {
    
    setLoading(true)
    const response = await api.aripiprazole();
    const d = handleData(response)
    setData( d )
    setLoading(false)
           // NO MEMORY LEAK
    setValue({ key: 'value' });
    }



    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(    {  'col1': response[i].id,
                                          'col2': response[i].Sample,
                                          'col3': response[i].Drug,
                                          'col4': response[i].Source,
                                          'col5': response[i].Name,
                                          'col6': response[i].Url,
                                          'col7': response[i].Gene,
                                          'col8': response[i].Diplo,
                                          'col9': response[i].ActivityScore,
                                          'col10': response[i].Phenotype,
                                          'col11': response[i].Implication,
                                          'col12': response[i].Recommendation,
                                          'col13': response[i].Classification,
                                          'col14': response[i].Consideration,
                                          'col15': response[i].owner,
},
                                  );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
          
        {
          id: 'col1',
          header: 'ID',
          accessorKey: 'col1',
          cell: info => info.getValue(),
          },
          {
            id: 'col3',
            header: 'Drug',
            accessorKey: 'col3',
            cell: info => info.getValue(),
            },
          {
            id: 'col4',
            header: 'Source',
            accessorKey: 'col4',
            cell: info => info.getValue(),
            },
            {
              id: 'col5',
              header: 'Name',
              accessorKey: 'col5',
              cell: info => info.getValue(),
              },
                {
                  id: 'col7',
                  header: 'Gene',
                  accessorKey: 'col7',
                 cell: info => info.getValue(),
                  },
                  {
                    id: 'col8',
                    header: 'My Diplotype',
                    accessorKey: 'col8',
                    cell: info => info.getValue(),
                    },
                      {
                        id: 'col9',
                        Header: 'ACTIVITY SCORE',
                        accessor: 'col9',
                      },
                      {
                        id: 'col10',
                        header: 'My Phenotype',
                        accessorKey: 'col10',
                        cell: info => info.getValue(),
                      },
                      {
                        id: 'col11',
                        header: 'Implication',
                        accessorKey: 'col11',
                        cell: info => info.getValue(),
                      },
                      {
                        id: 'col12',
                        header: 'Recommendation',
                        accessorKey: 'col12',
                        cell: info => info.getValue(),
                      },
                      {
                        id: 'col13',
                        header: 'Classification',
                        accessorKey: 'col13',
                        cell: info => info.getValue(),
                      },
                      {
                        id: 'col14',
                        header: 'Consideration',
                        accessorKey: 'col14',
                        cell: info => info.getValue(),
                      },
                      {
                        id: 'col6',
                        header: 'Url',
                        accessorKey: 'col6',
                        cell: info => info.getValue(),
                        },
               
      ],
      []
      )

return (

<div>
{ loading && <span> Please wait ... fetching data </span>}

      <TableComp columns={columns} data={data} />

</div>

);
}